import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from '../../services/user.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { toIntPhoneNumber, UK_PHONE_PATTERN } from '../../public-api';

@Component({
  selector: 'brt-verify-mobile-phone',
  standalone: true,
  imports: [
    CommonModule, FormsModule,
    MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule,
  ],
  templateUrl: './verify-mobile-phone.component.html',
  styleUrl: './verify-mobile-phone.component.css'
})
export class VerifyMobilePhoneComponent {
  constructor(private userService: UserService) { }

  @Input() suggestedPhone?: string;
  @Output() phoneVerified = new EventEmitter<string>();

  phonePattern = UK_PHONE_PATTERN;
  phoneNumber: string;
  phoneAuthorized: boolean;
  ngOnInit() {
    this.userService.current$.subscribe(user => {
      if (!user) return;
      this.phoneAuthorized = !!user.Identity?.PhoneNumber;
      if (this.phoneAuthorized) this.phoneNumber = this.normalizeUkPhone(user.Identity.PhoneNumber);
      else {
        this.phoneNumber = this.normalizeUkPhone(this.suggestedPhone);
      }
    });
    this.phoneNumber = this.normalizeUkPhone(this.suggestedPhone);
  }

  private normalizeUkPhone(phone?: string): string {
    return (phone || '')
      .replace(/\s+/g, '')
      .replace(/^\+44/, '')
      .replace(/^0/, '')
      .replace(/\D/g, '')
      .slice(0, 10);
  }

  busy: boolean;
  error: any;
  async saveMobilePhone() {
    this.error = null;
    this.busy = true;
    try {
      this.phoneNumber = toIntPhoneNumber(this.phoneNumber);
      await this.userService.savePhoneNumber(this.phoneNumber);
      this.phoneAuthorized = true;
      await this.userService.refresh(this.userService.currentFirebaseUser);
      this.phoneVerified.emit(this.phoneNumber);
    } catch (error) {
      this.error = error;
    } finally {
      this.busy = false;
    }
  }
}
